export { validator };
class validator {
    msg = "";
    value = "";
    strong = 0;
    one_numeric = 0;
    one_upper = 0;
    max_8 = 0;

    constructor() {
        this.msg = "";
        this.value = "";
    }
    set(value) {
        if (typeof value === "undefined") return this;
        this.msg = "";
        this.value = value;
        return this;
    }
    required(msg) {
        if(typeof this.value!="undefined") {
            msg = this.check(this.value, msg);
            if (msg) this.msg = msg;
            return this;
        }
        this.msg = msg;
        return this;
    }
    numeric(msg) {
        const regex = new RegExp(/^[0-9\b]+$/);
        msg = this.check(regex.test(this.value.trim()), msg);
        if (msg) this.msg = msg;
        return this;
    }
    email(msg) {
        const regex = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|([\-w]+(?:\.[\-w]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
        msg = this.check(regex.test(String(this.value.trim()).toLowerCase()), msg);
        if (msg) this.msg = msg;
        return this;
    }
    same(value2, msg) {
        msg = this.check(this.value.trim() == value2.trim(), msg);
        if (msg) this.msg = msg;
        return this;
    }
    url(msg) {
        const regex = new RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
        msg = this.check(regex.test(String(this.value.trim()).toLowerCase()), msg);
        if (msg) this.msg = msg;
        return this;
    }
    range(min = 1, max = 255, msg) {
        msg = this.check((parseFloat(this.value.trim()) >= min && parseFloat(this.value.trim()) <= max), msg);
        if (msg) this.msg = msg;
        return this;
    }
    min_max(min = 1, max = 255, msg) {
        msg = this.check((this.value.trim().length >= min && this.value.trim().length <= max), msg);
        if (msg) this.msg = msg;
        return this;
    }
    length(length = 0, msg) {
        msg = this.check((this.value.trim().length == length), msg);
        if (msg) this.msg = msg;
        return this;
    }
    alphabet(msg) {
        const regex = new RegExp(/[^A-Za-z]/ig);
        msg = this.check(!(regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    alphanumeric(msg) {
        const regex = new RegExp(/[^A-Za-z]/ig);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    pancard(msg) {
        const regex = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    empid_special_char(msg) {
        const regex = new RegExp(/^[-\w\s-_]+$/i);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    special_char(msg) {
        const regex = new RegExp(/^[-\w\s-_&']+$/i);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    american_express_card(msg) {
        const regex = new RegExp(/^(?:3[47][0-9]{13})$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    visa_card(msg) {
        const regex = new RegExp(/^(?:4[0-9]{12}(?:[0-9]{3})?)$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    master_card(msg) {
        const regex = new RegExp(/^(?:5[1-5][0-9]{14})$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    discover_card_number(msg) {
        const regex = new RegExp(/^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    dinner_club_card(msg) {
        const regex = new RegExp(/^(?:3(?:0[0-5]|[68][0-9])[0-9]{11})$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    jcb_card(msg) {
        const regex = new RegExp(/^(?:(?:2131|1800|35\d{3})\d{11})$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    cvv(msg) {
        const regex = new RegExp(/^[0-9]{3,4}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }
    expiry_date(msg) {
        //const regex = new RegExp(/(0|1)[0-9]\/(19|20)[0-9]{2}/);
        const regex = new RegExp(/(0|1)[0-9]\/[0-9]{2}/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) {
            this.msg = msg;
            return this;
        } else {
            let date_array = this.value.split('/');
            let month = date_array[0] - 1;
            let year = date_array[1];
            let source_date = new Date();
            if (year >= source_date.getFullYear()) {
                if (month >= source_date.getMonth()) {
                    this.msg = '';
                } else {
                    this.msg = msg;
                }
            } else {
                this.msg = msg;
            }
        }
        return this;
    }
    credit_card(msg) {
        const regex = new RegExp("^[0-9]{13,19}$");
        if (!regex.test(this.value.trim())) {
            msg = this.check(false, msg);
            if (msg) this.msg = msg;
            return this;
        } else {
            msg = this.check(this.check_credit_card(this.value.trim()), msg);
            if (msg) this.msg = msg;
            return this;
        }
    }

    check_credit_card(val) {
        let checksum = 0; // running checksum total
        let j = 1; // takes value of 1 or 2

        // Process each digit one by one starting from the last
        for (let i = val.length - 1; i >= 0; i--) {
            let calc = 0;
            // Extract the next digit and multiply by 1 or 2 on alternative digits.
            calc = Number(val.charAt(i)) * j;

            // If the result is in two digits add 1 to the checksum total
            if (calc > 9) {
                checksum = checksum + 1;
                calc = calc - 10;
            }

            // Add the units element to the checksum total
            checksum = checksum + calc;

            // Switch the value of j
            if (j == 1) {
                j = 2;
            } else {
                j = 1;
            }
        }

        //Check if it is divisible by 10 or not.
        return (checksum % 10) == 0;
    }
    password_numeric(msg) {
        const regex = new RegExp(/^(?=.*?[0-9]).{1,}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        else {
            this.strong++;
            this.one_numeric = 1;
        }
        return this;
    }
    password_upper(msg) {
        const regex = new RegExp(/^(?=.*?[A-Z]).{1,}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        else {
            this.strong++;
            this.one_upper = 1;
        }
        return this;
    }
    password_match(msg, pass, confirmPass) {
        if (pass != confirmPass) {
            if (msg) this.msg = msg;
            this.passwordMatch = 1;
        } else {
            this.passwordMatch = 0;
        }
        msg = msg;

        return this;
    }
    password_8(msg) {
        const regex = new RegExp(/^(?=.*)[a-zA-Z0-9!@#$%^&*-_=]{8,1000}$/);
        // const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/);
        // const regex = new RegExp(/^([A-Za-z0-9]).{7,}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        else {
            this.strong++;
            this.max_8 = 1;
        }
        return this;
    }
    password(msg) {
        //const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/);
        const regex = new RegExp(/^(?=.*?[A-Z])(?=.*?[0-9]).{8,}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        else {
            this.strong++;
            this.max_8 = 1;
        }
        return this;
    }
    pin(msg) {
        const regex = new RegExp(/^([0-9]).{5}$/);
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }

    check(value, msg) {
        if (value) return "";
        else return msg;
    }

    reg_mac_address(msg) {
        const regex = new RegExp('^([0-9a-fA-F]{2}(?:(?:-[0-9a-fA-F]{2}){5}|(?::[0-9a-fA-F]{2}){5}|[0-9a-fA-F]{10}))$');
        msg = this.check((regex.test(this.value.trim())), msg);
        if (msg) this.msg = msg;
        return this;
    }

    static submitForm = (formErrors) => {
        if (Object.keys(formErrors).length == 0) {
          return false;
        }
    
        let flag = true;
        let hasFalse = Object.keys(formErrors).some((keyName) => {
          if (formErrors[keyName]) {
            flag = false;
          }
        });
        return flag;
    };
    
}

